import React from 'react';
import PropTypes from 'prop-types';
import './NotificationBanner.scss';
import Image from '../Image/Image';
import CloseOutline from '../../assets/images/close-outline.svg';

const NotificationBanner = ({ headline, message, onClose, alertIcon }) => {
  return (
    <div className="vve-notification-notification">
      <div className="vve-notification-icon-title-close">
        <Image className="vve-notification-status-alert-solid" src={alertIcon} alt="Alert" />
        <div className="vve-notification-title">
          <div className="vve-notification-headline">{headline}</div>
        </div>
        <button className="vve-notification-icon" onClick={onClose} tabIndex={0} aria-label="Close" style={{ cursor: 'pointer' }}>
          <Image className="vve-notification-close-outline" src={CloseOutline} alt="Close" />
        </button>
      </div>
      <div className="vve-notification-content">
        <div className="vve-notification-caption">{message}</div>
      </div>
    </div>
  );
};

NotificationBanner.propTypes = {
  message: PropTypes.string,
  headline: PropTypes.string,
  onClose: PropTypes.func.isRequired
};

export default NotificationBanner;
